import { render } from "./new-community-camera.vue?vue&type=template&id=0e3966c5&scoped=true&ts=true"
import script from "./new-community-camera.vue?vue&type=script&lang=ts"
export * from "./new-community-camera.vue?vue&type=script&lang=ts"

import "./new-community-camera.vue?vue&type=style&index=0&id=0e3966c5&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3966c5"]])

export default __exports__